import BaseApiService from './baseApiService';
import { AuthDataRequest, AuthDataResponse } from '../contracts';

class AuthApiService extends BaseApiService {
    login = async (request: AuthDataRequest) => {
        return await this.post<AuthDataResponse, AuthDataRequest>('auth/login', request);
    };
}

export default new AuthApiService();
